/**
 * Checks if number is in between upper and lower
 * Has an option to choose whether upper or lower bounds are inclusive
 * @param IsInBetweenProps
 * @returns boolean
 */
var isInBetween = function isInBetween(_ref) {
  var lower = _ref.lower,
    upper = _ref.upper,
    toBeCompared = _ref.toBeCompared,
    _ref$isLowerBoundIncl = _ref.isLowerBoundInclusive,
    isLowerBoundInclusive = _ref$isLowerBoundIncl === void 0 ? false : _ref$isLowerBoundIncl,
    _ref$isUpperBoundIncl = _ref.isUpperBoundInclusive,
    isUpperBoundInclusive = _ref$isUpperBoundIncl === void 0 ? false : _ref$isUpperBoundIncl;
  if (isLowerBoundInclusive && isUpperBoundInclusive && toBeCompared >= lower && toBeCompared <= upper) {
    return true;
  } else if (isLowerBoundInclusive && toBeCompared >= lower && toBeCompared < upper) {
    return true;
  } else if (isUpperBoundInclusive && toBeCompared > lower && toBeCompared <= upper) {
    return true;
  } else if (toBeCompared > lower && toBeCompared < upper) {
    return true;
  } else {
    return false;
  }
};
export default isInBetween;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/isInBetween.js
// module id = 1250
// module chunks = 11